module.exports = __webpack_public_path__ + "img/ico-reply-td.8e455d94.svg";